<template>

    <FloatingPanel :title="title" :width="calculatedWidth">

        <div class="canvas::editor-website-editors-loop-owlCarousel-LoopItemPanel">

            <slot/>

            <div class="m-5">

                <div class="mb-1 text-gray-600">Positie van slide</div>

                <small class="block mb-3 text-gray-500 text-muted">Bepaal in welke volgorde deze
                    slide in de slider getoond wordt.</small>

                <div class="flex">

                    <button
                        class="btn btn-blue"
                        :class="{ 'opacity-50': loopIndex == 0 }"
                        :disabled="loopIndex == 0"
                        @click="mutateIndex(-1)">
                        <i class="fa fa-arrow-left mr-1"></i>
                        Verplaats terug
                    </button>

                    <button
                        class="btn btn-blue ml-3"
                        :class="{ 'opacity-50': loopIndex == loopItems.length - 1 }"
                        :disabled="loopIndex == loopItems.length - 1"
                        @click="mutateIndex(1)">
                        Verplaats verder
                        <i class="fa fa-arrow-right ml-1"></i>
                    </button>

                </div>

            </div>

        </div>

        <template v-slot:actions>
            <slot name="actions">
                <div class="defaultActions flex">

                    <slot name="actionsExtra"></slot>

                    <button
                        class="bg-red-400 inline-flex justify-center py-3 rounded-none text-white w-full"
                        @click="removeItem">
                        <i class="fa fa-trash mr-1"></i> Verwijder
                    </button>

                </div>

            </slot>
        </template>

    </FloatingPanel>

</template>

<script>

import LoopItemPanel from "../LoopItemPanel";
import FloatingPanel from "../../panels/FloatingPanel";

export default {

    extends: LoopItemPanel,

    components: {
        FloatingPanel,
    },

    props: {
        title: {
            type: String,
            default()
            {
                // @ugly Getting the editor this way and get the label.
                return this.$parent.selection.currentSelection.editableData?.label || 'Slide';
            },
        },
        width: Number,
    },

    methods: {

        mutateIndex(mutation)
        {
            // Get original data.
            let originals = {
                loopIndex2canvasBlocks: {},
                loopItems: [...this.loopItems],
            };

            // Fill original canvas blocks map.
            for (let child of this.loopEditorComponent.$children)
                originals.loopIndex2canvasBlocks[child.loopIndex] = child.canvasBlocks;

            // Determine index to swap with.
            let swapWithIndex = this.loopIndex + mutation;

            if (swapWithIndex < 0)
                swapWithIndex = this.loopItems.length - 1;

            else if (swapWithIndex > this.loopItems.length - 1)
                swapWithIndex = 0;

            // Update indices.
            for (let swap of [
                [swapWithIndex, this.loopIndex],
                [this.loopIndex, swapWithIndex]
            ]) {
                // Swap canvas blocks.
                for (let canvasBlock of originals.loopIndex2canvasBlocks[swap[0]]) {
                    // Determine key suffix (after "loop.x")
                    let keySuffix = canvasBlock.key.split('.').slice(2).join('.');

                    // Set new key.
                    this.$set(canvasBlock, 'key', this.loopKey + '.' + swap[1] + '.' + keySuffix);
                }

                // Set in loop items.
                this.$set(this.loopItems, swap[0], originals.loopItems[swap[1]]);
            }

            // Set selection to the new element. That element is not this element right now, but it will be. The Selection stores the unique CSS selector, and after new HTML has been received, it will select this element in its new position.
            let newSelection = this.loopEditorComponent.getLoopItemEditorByIndex(swapWithIndex);

            this.$pageComponent().selection.setSelection(newSelection);
        },

    },

}

</script>

<style lang="scss" scoped>

.canvas\:\:editor-website-editors-loop-owlCarousel-LoopItemPanel {

    .actions:first-child {
        @apply pt-3;
    }

}

</style>
